import React, { useEffect, useState } from "react";

import { Loading } from "../../../Other/Loading";
import { Link } from "react-router-dom";
import { debounce } from "lodash";

import axiosInstance from "../../../../axios";
import { getS3URL } from "../../../../_helpers";
import { documentTypeUrl } from "../../../../_constants/staticData";

const CreateBundle = ({
  selectedCourses,
  setselectedCourses,
  editbundle,
  announcement,
  setSelectAnnounceCourse,
  selectAnnounceCourse,
}) => {
  const [searchBundleCourse, setSearchBundleCourse] = useState([]);
  //console.log("searchBundleCourse", searchBundleCourse);
  const [query, setQuery] = useState("");
  const [showAutoComplete, setShowAutocomplete] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  const parseAndShortDescription = (description) => {
    const parsed = description?.replace(/<[^>]*>/g, "");
    if (parsed?.length > 180) {
      const shortenend = parsed?.slice(0, 280);
      return shortenend;
    }
    return parsed;
  };

  useEffect(() => {
    if (selectedCourses && selectedCourses.courses.length > 0) {
      setSearchBundleCourse(selectedCourses.courses);
    }
  }, [selectedCourses]);

  useEffect(() => {
    if (selectAnnounceCourse && selectAnnounceCourse.length > 0) {
      setSearchBundleCourse(selectAnnounceCourse);
    }
  }, []);

  const fetchSuggestions = async (value, type) => {
    setQuery(value);

    if (value?.length > 3) {
      setShowAutocomplete(true);

      try {
        const { data } = await axiosInstance.get(
          `/search/course?search=${value}${type ? `&type=${type}` : ""}`
        );

        setSuggestions(
          data.data.length > 0
            ? data.data
              .filter((item) => item.Status === 3)
              .map((course) => ({
                CourseName: course.CourseName,
                ID: course.ID,
                subCategory: course.SubCategory,
                Category: course.Category,
                imageFiles: course.imageFiles,
                Status: course.Status,
                Description: course.description,
                Duration: course.Duration,
                Language: course.Language,
              }))
            : [{ CourseName: "No Records Found" }]
        );
      } catch (error) {
        console.error("Error fetching suggestions:", error.message);
        setSuggestions([{ CourseName: "Error fetching data" }]);
      }
    } else {
      setShowAutocomplete(false);
    }
  };


  useEffect(() => {
    const handleClickStatus = (event) => {
      const searchInput = document.getElementById("bundle-search");
      const autoComplete = document.getElementById("bundle-auto-complete");
      if (searchInput && autoComplete) {
        const isClickInside = searchInput.contains(event.target)
          ? true
          : autoComplete.contains(event.target)
            ? false
            : false;

        if (!isClickInside) {
          setShowAutocomplete(false);
        }
      }
    };
    document.addEventListener("click", handleClickStatus);
    return () => document.removeEventListener("click", handleClickStatus);
  }, []);

  useEffect(() => {
    return () => handleChangeDebounce.cancel();
  }, []);
  const handleFocus = (suggestions) => {
    if (suggestions.length > 0 && query.length > 3) {
      setShowAutocomplete(true);
    }
  };
  const handleChangeDebounce = debounce(
    (value) => fetchSuggestions(value, "dashboard"),
    500
  );

  const courseStatusCallback = (type) => {
    switch (type) {
      case 1:
        return { className: "text-draft", text: "Draft" };
      case 2:
        return { className: "text-review", text: "In Review" };
      case 3:
        return { className: "text-published", text: "Published" };
      case 4:
        return { className: "text-archive", text: "Archive" };
      default:
        return null;
    }
  };
  const getHighlightedText = (text, highlight) => {
    const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const parts = text?.split(new RegExp(`(${escapedHighlight})`, "gi"));
    return (
      <span>
        {parts?.map((part, index) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span style={{ fontWeight: "bold" }} key={index}>
              {part}
            </span>
          ) : (
            part
          )
        )}
      </span>
    );
  };

  useEffect(() => {
    if (announcement && searchBundleCourse && searchBundleCourse.length > 0) {
      setSelectAnnounceCourse(searchBundleCourse);
    }
  }, [searchBundleCourse]);

  const selectionHandler = (event, data) => {
    let isChecked = event.target.checked;

    if (isChecked && searchBundleCourse && searchBundleCourse?.length > 0) {
      const status = searchBundleCourse.some((items) => items.ID !== data.ID);
      if (status) {
        setSearchBundleCourse((prevArray) => {
          return [...prevArray, data];
        });
      }
      if (editbundle && selectedCourses && selectedCourses?.courses) {
        setselectedCourses({
          ...selectedCourses,
          courses: [...selectedCourses?.courses, data],
        });
      }
    } else if (
      !isChecked &&
      searchBundleCourse &&
      searchBundleCourse?.length > 0
    ) {
      setSearchBundleCourse(
        searchBundleCourse.filter((item) => item.ID !== data.ID)
      );
    } else {
      setSearchBundleCourse((prevArray) => {
        return [...prevArray, data];
      });
      // setselectedCourses({
      //   ...selectedCourses,
      //   courses: [...selectedCourses?.courses, data],
      // });
    }
    if (!isChecked && selectedCourses && selectedCourses?.courses?.length > 0) {
      let updatedBundleCourse = selectedCourses?.courses.filter(
        (item) => item.ID !== data.ID
      );
      setselectedCourses({ ...selectedCourses, courses: updatedBundleCourse });
    }
  };

  const bundleStatusChangeHandler = (value) => {
    setSearchBundleCourse(
      searchBundleCourse.filter((item) => item.ID !== value)
    );
    if (selectedCourses && selectedCourses?.courses?.length > 0) {
      let updatedBundleCourse = selectedCourses?.courses.filter(
        (item) => item.ID !== value
      );
      setselectedCourses({ ...selectedCourses, courses: updatedBundleCourse });
    } else if (selectAnnounceCourse && selectAnnounceCourse.length > 0) {
      let updatedBundleCourse = selectAnnounceCourse.filter(
        (item) => item?.courseId !== value
      );
      setSearchBundleCourse(updatedBundleCourse);
      setSelectAnnounceCourse(updatedBundleCourse);
    }
  };
  const getCheckedStatus = (currentID) => {
    if (searchBundleCourse && searchBundleCourse.length > 0) {
      const status =
        suggestions &&
        suggestions.length > 0 &&
        searchBundleCourse &&
        searchBundleCourse.length > 0 &&
        searchBundleCourse.some(
          (items) => items?.ID === currentID || items?.courseId === currentID
        );

      return status;
    }
    return false;
  };
  const handleFormSubmit = (event) => {
    event.preventDefault();
    setShowAutocomplete(true);
  };

  return (
    <div>
      <section className={!announcement ? "container-wrapper" : ""}>
        <div className={!announcement ? "create-bundle-color" : ""}>
          {!announcement && (
            <div>
              <p>Create a Course Bundle</p>
              <div>
                <p>
                  To Create a Course Bundle , you will need to choose a minimum
                  of 2 Published Courses Only to start, maximum of 50 Courses.
                </p>
              </div>
            </div>
          )}
          <form id="bundle-form" onSubmit={(event) => handleFormSubmit(event)}>
            <div className="form-group">
              <div className="input-wrapper position-a createBundler-Container">
                <input
                  id="bundle-search"
                  type="text"
                  onChange={(event) => handleChangeDebounce(event.target.value)}
                  onFocus={() => handleFocus(suggestions)}
                  placeholder={announcement ? "Search Course" : "Bundle Course"}
                  className="form-control"
                  aria-label="Search"
                  required
                />{" "}
                <div className="serach-icon"></div>
              </div>
            </div>
          </form>

          {showAutoComplete && (
            <p className="bundleSerachContainer-SearchResult">Search result</p>
          )}
        </div>
        <div></div>
        {showAutoComplete ? (
          <div
            className="search-suggestions searchBundle-Container"
            id="bundle-auto-complete"
          >
            {suggestions.length > 0 ? (
              <ul>
                {suggestions.map((suggestion, index) => (
                  <li key={index}>
                    {suggestion.CourseName !== "No Records Found" && (
                      <div className="courseBundle-SearchBoxSelection">
                        <input
                          type="checkbox"
                          checked={getCheckedStatus(suggestion.ID)}
                          onChange={(e) => selectionHandler(e, suggestion)}
                        />
                      </div>
                    )}
                    <div>
                      {getHighlightedText(suggestion.CourseName, query)}
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <Loading />
            )}
          </div>
        ) : null}
        {searchBundleCourse &&
          searchBundleCourse.length > 0 &&
          searchBundleCourse.map((item) => (
            <div
              className="main"
              style={{
                height: "150px",
                backgroundColor: "rgb(229, 229, 229)",
              }}
            >
              <input
                type="checkbox"
                checked={true}
                onChange={() =>
                  bundleStatusChangeHandler(
                    item?.ID ? item?.ID : item?.courseId
                  )
                }
                style={{ width: "50px" }}
              />
              <div
                className="img-container"
                style={{ height: true && "120px" }}
              >
                <img
                  src={
                    item?.imageFiles
                      ? item?.imageFiles.length > 0
                        ? getS3URL(item.imageFiles[0]?.fileName)
                        : documentTypeUrl.brokenImage
                      : item?.fileName && getS3URL(item?.fileName)
                  }
                  className="img"
                  alt="courseImage"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = require("../../../../assets/images/bgimages.webp");
                  }}
                />
              </div>
              <div className="content">
                <div className="content-inner">
                  <div className="inner-top">
                    <div className="inner-top-flex">
                      <div className="left">
                        <p
                          className={
                            courseStatusCallback(item?.Status)?.className
                          }
                        >
                          {courseStatusCallback(item?.Status)?.text}
                        </p>
                        <p className="course-category"> {item?.Category}</p>
                      </div>
                      <div className="right">
                        {/* <p>{item.name}</p> */}
                        <p>{item.subCategory}</p>
                        <p>
                          {item.CourseName != null ? item?.CourseName : ""}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="inner-top-flex">
                      <p
                        className="description-text"
                        dangerouslySetInnerHTML={{
                          __html:
                            item?.Description?.length > 120
                              ? parseAndShortDescription(
                                item?.Description
                              ).substring(0, 120) + "..."
                              : parseAndShortDescription(item?.Description),
                        }}
                      ></p>

                      <p
                        className="description-text"
                        dangerouslySetInnerHTML={{
                          __html:
                            item?.description?.length > 120
                              ? parseAndShortDescription(
                                item?.description
                              ).substring(0, 120) + "..."
                              : parseAndShortDescription(item?.description),
                        }}
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

        {announcement !== true && (
          <>
            {" "}
            {searchBundleCourse.length >= 2 &&
              searchBundleCourse.length <= 50 &&
              !editbundle && (
                <div className="!absolute">
                  <Link
                    className=" btn-5"
                    to={{
                      pathname: "/dashboard/coursebuilder",
                      courseStatus: "createBundle",
                      courseSelected: searchBundleCourse,
                    }}
                  >
                    NEXT - CREATE BUNDLE
                  </Link>
                </div>
              )}
          </>
        )}
      </section>
    </div>
  );
};

export default CreateBundle;
